import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Header from "components/Headers/Header";
import VerComentarios from "views/examples/VerComentarios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

const CreaComentarios = (props) => {
  const cookie = new Cookies();
  const [postNombre, setPostNombre] = useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState({
    postData: false,
    avanza: false,
    devuelve: false,
  });

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  const postData = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, postData: true }));

    const fecha = new Date();
    const fechaBogota = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(fecha);
    const fechaCreacion = fechaBogota.replace(" ", "T");

    try {
      const response = await axios.post(
        "https://contratosback.azurewebsites.net/api/v1/CreaComentarios",
        {
          solicitudId: JSON.stringify(props.id),
          comentarios: postNombre,
          usuarioId: cookie.get("id") || "109",
          fechaCreacion,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );
      console.log(response.data);
      Swal.fire({
        icon: "success",
        title: "¡Comentario creado!",
        text: "Se ha guardado el comentario correctamente.",
        timer: 2000,
        showConfirmButton: false,
        willOpen: zIndexFix,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al crear",
        text: error.message,
        willOpen: zIndexFix,
      });
    } finally {
      setLoading((prev) => ({ ...prev, postData: false }));
    }
  };

  const Avanza = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, avanza: true }));

    try {
      const response = await axios.post(
        `https://contratosback.azurewebsites.net/api/v1/EnviaPaso/${props.paso}/avanza/${props.id}`,
        {},
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );
      console.log(response.data);
      Swal.fire({
        icon: "success",
        title: "Avanzado correctamente",
        text: response.data,
        timer: 9000,
        showConfirmButton: true,
        willOpen: zIndexFix,
      }).then(() => {
        window.location.reload("/");
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al avanzar",
        text: error.message,
        willOpen: zIndexFix,
      });
    } finally {
      setLoading((prev) => ({ ...prev, avanza: false }));
    }
  };

  const Devuelve = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, devuelve: true }));

    try {
      const response = await axios.post(
        `https://contratosback.azurewebsites.net/api/v1/EnviaPaso/${props.paso}/devuelve/${props.id}`,
        {},
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );
      console.log(response.data);
      Swal.fire({
        icon: "success",
        title: "Contrato devuelto",
        text: "Se devolvió correctamente.",
        timer: 2000,
        showConfirmButton: false,
        willOpen: zIndexFix,
      }).then(() => {
        window.location.reload("/");
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al devolver",
        text: error.message,
        willOpen: zIndexFix,
      });
    } finally {
      setLoading((prev) => ({ ...prev, devuelve: false }));
    }
  };

  return (
    <>
      {cookie.get("tipo_Usuario") != 5 ? (
        <button
          className="btn btn-primary"
          onClick={handleOpenModalTest}
          style={{ padding: "5px 5px", fontSize: "10px" }}
        >
          Realizar Comentarios y/o Aprobar
        </button>
      ) : (
        <button
          className="btn btn-primary"
          onClick={handleOpenModalTest}
          style={{ padding: "5px 5px", fontSize: "10px" }}
        >
          Visualizar comentarios
        </button>
      )}
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          cerrar
        </button>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0" />
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Comentarios caso:{props.id}
                    </h6>
                    <FormGroup>
                      <Input
                        type="textarea"
                        placeholder="Escriba aquí"
                        onChange={(e) => setPostNombre(e.target.value)}
                      />
                    </FormGroup>
                    <button
                      className="btn btn-primary btn-lg"
                      onClick={postData}
                      disabled={loading.postData}
                    >
                      {loading.postData ? "Guardando..." : "Guardar Comentario"}
                    </button>

                    <div>
                      <h6 className="heading-small text-muted mb-4">
                        OPCIONES
                      </h6>

                      <button
                        className="btn btn-danger btn-lg"
                        onClick={Devuelve}
                        disabled={loading.devuelve}
                        title="Esta opción es en dado caso que no esté de acuerdo con algún ítem del contrato"
                      >
                        {loading.devuelve
                          ? "Devolviendo..."
                          : "DEVOLVER CONTRATO"}
                      </button>

                      {!window.location.href
                        .toLowerCase()
                        .includes("autenticacion") && (
                        <button
                          className="btn btn-success btn-lg"
                          onClick={Avanza}
                          disabled={loading.avanza}
                        >
                          {loading.avanza
                            ? "Enviando al siguiente aprobador..."
                            : "SIGUIENTE APROBACIÓN"}
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <br />
        <br />
        <br />
        <br />
        {cookie.get("tipo_Usuario") != null && <VerComentarios id={props.id} />}
      </ReactModal>
    </>
  );
};

export default CreaComentarios;
